/**
 * 用户接口
 * 用户接口API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The ForgotPasswordSendCodeVo model module.
   * @module token/model/ForgotPasswordSendCodeVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>ForgotPasswordSendCodeVo</code>.
   * @alias module:token/model/ForgotPasswordSendCodeVo
   * @class
   */
  var exports = function() {
    var _this = this;




  };

  /**
   * Constructs a <code>ForgotPasswordSendCodeVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:token/model/ForgotPasswordSendCodeVo} obj Optional instance to populate.
   * @return {module:token/model/ForgotPasswordSendCodeVo} The populated <code>ForgotPasswordSendCodeVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'phone')) {
        obj['phone'] = ApiClient.convertToType(data['phone'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'message')) {
        obj['message'] = ApiClient.convertToType(data['message'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'success')) {
        obj['success'] = ApiClient.convertToType(data['success'], 'Boolean');
      }
    }
    return obj;
  }

  /**
   * 手机号
   * @member {String} phone
   */
  exports.prototype['phone'] = undefined;
  /**
   * 发送结果消息
   * @member {String} message
   */
  exports.prototype['message'] = undefined;
  /**
   * 是否发送成功
   * @member {Boolean} success
   */
  exports.prototype['success'] = undefined;



  export default exports;
;


